const data = {
    "list": [
        [
            {
                "id": "15",
                "status": "default",
                "position": [1, 5],
                "content": {
                    "title": {title: "标题", tag: {text: "合格", type: "default"}},
                    "content": [
                        "勾朝辉",
                        "实：2023-06-13",
                        "应：2023-06-13",
                        "应：2023-06-13"
                    ]
                },
                "next": "16"
            },
            {
                "id": "16",
                "status": "default",
                "position": [1, 6],
                "content": {
                    "title": {title: "标题", link: {show: true, callback: () => {console.log(1, 6)}}},
                    "content": [
                        "勾朝辉",
                        "实：2023-06-13",
                        "应：2023-06-13"
                    ]
                },
                "next": "29"
            }
        ],
        [
            {
                "id": "21",
                "status": "default",
                "position": [2, 1],
                "content": {
                    "title": {title: "标题", help: {show: true, callback: () => {console.log(2, 1, "help")}}},
                    "content": [
                        "勾朝辉",
                        "实：2023-06-13",
                        "应：2023-06-13"
                    ]
                },
                "next": "22"
            },
            {
                "id": "22",
                "status": "default",
                "position": [2, 2],
                "content": {
                    "title": "这里是标题",
                    "content": [
                        "勾朝辉",
                        "实：2023-06-13",
                        "应：2023-06-13"
                    ]
                },
                "next": "23"
            },
            {
                "id": "23",
                "status": "default",
                "position": [2, 3],
                "content": {
                    "title": "这里是标题",
                    "content": [
                        "勾朝辉",
                        "实：2023-06-13",
                        "应：2023-06-13"
                    ]
                },
                "next": "24"
            },
            {
                "id": "24",
                "status": "default",
                "position": [2, 4],
                "content": {
                    "title": "这里是标题",
                    "content": [
                        "勾朝辉",
                        "实：2023-06-13",
                        "应：2023-06-13"
                    ]
                },
                "next": ["15", "25", "35", "45"]
            },
            {
                "id": "25",
                "status": "default",
                "position": [2, 5],
                "content": {
                    "title": "这里是标题",
                    "content": [
                        "勾朝辉",
                        "实：2023-06-13",
                        "应：2023-06-13"
                    ]
                },
                "next": "26"
            },
            {
                "id": "26",
                "status": "default",
                "position": [2, 6],
                "content": {
                    "title": "这里是标题",
                    "content": [
                        "勾朝辉",
                        "实：2023-06-13",
                        "应：2023-06-13"
                    ]
                },
                "next": "27"
            },
            {
                "id": "27",
                "status": "default",
                "position": [2, 7],
                "content": {
                    "title": "这里是标题",
                    "content": [
                        "勾朝辉",
                        "实：2023-06-13",
                        "应：2023-06-13"
                    ]
                },
                "next": "29"
            },
            {
                "id": "29",
                "status": "default",
                "position": [2, 9],
                "content": {
                    "title": "这里是标题",
                    "content": [
                        "勾朝辉",
                        "实：2023-06-13",
                        "应：2023-06-13"
                    ]
                },
                "next": "210"
            },
            {
                "id": "210",
                "status": "default",
                "position": [2, 10],
                "content": {
                    "title": "这里是标题",
                    "content": [
                        "勾朝辉",
                        "实：2023-06-13",
                        "应：2023-06-13"
                    ]
                }
            }
        ],
        [
            {
                "id": "35",
                "status": "default",
                "position": [3, 5],
                "content": {
                    "title": "这里是标题",
                    "content": [
                        "勾朝辉",
                        "实：2023-06-13",
                        "应：2023-06-13"
                    ]
                },
                "next": "36"
            },
            {
                "id": "36",
                "status": "default",
                "position": [3, 6],
                "content": {
                    "title": "这里是标题",
                    "content": [
                        "勾朝辉",
                        "实：2023-06-13",
                        "应：2023-06-13"
                    ]
                },
                "next": "37"
            },
            {
                "id": "37",
                "status": "default",
                "position": [3, 7],
                "content": {
                    "title": "这里是标题",
                    "content": [
                        "勾朝辉",
                        "实：2023-06-13",
                        "应：2023-06-13"
                    ]
                },
                "next": "38"
            },
            {
                "id": "38",
                "status": "default",
                "position": [3, 8],
                "content": {
                    "title": "这里是标题",
                    "content": [
                        "勾朝辉",
                        "实：2023-06-13",
                        "应：2023-06-13"
                    ]
                },
                "next": "29"
            }
        ],
        [
            {
                "id": "45",
                "status": "default",
                "position": [4, 5],
                "content": {
                    "title": "这里是标题",
                    "content": [
                        "勾朝辉",
                        "实：2023-06-13",
                        "应：2023-06-13",
                    ]
                }
            },
        ],
    ],
    "group": [
        {
            "groupId": 0,
            title: "流程1：图纸审核",
            "group": ["15", "16"],
            color: "#5FB6C6"
        },
        {
            "groupId": 1,
            title: "流程2：文件审核",
            "group": ["25", "26", "27"],
            color: "#CCBD8C"
        },
        {
            "groupId": 2,
            title: "流程3：物料审核",
            "group": ["35", "36", "37", "38"],
            color: "#8973C9"
        },
    ],
}

export default data
